import React from 'react';
import { makeStyles, Typography } from 'housecall-ui';

import { SmallCardButton } from './SmallCardButton';

type Props = {
  timeslot: string;
  selected: boolean;
  onClick: () => void;
};

type StyleProps = {
  selected: boolean;
};

const useStyles = makeStyles((theme) => ({
  card: ({ selected }: StyleProps) => ({
    border: `1px solid ${selected ? theme.palette.primary.main : theme.palette.grey[200]}`,
  }),
  button: ({ selected }: StyleProps) => ({
    color: selected ? theme.palette.primary.main : theme.palette.text.primary,
    padding: theme.spacing(2),
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  }),
}));

export const TimeSlotElement = ({ timeslot, selected, onClick }: Props) => {
  const { button, card } = useStyles({ selected });

  return (
    <SmallCardButton onClick={onClick} classes={{ button, card }}>
      <Typography type="body1" align="center">
        {timeslot}
      </Typography>
    </SmallCardButton>
  );
};
